<template>
  <div :class="{ 'card-fullscreen' : card_fullscreen, 'mt-0' : !card_fullscreen }">

    <b-row :class="card_fullscreen ? 'full-screen' : ''">
      <b-col>
        <b-row class="align-items-center table-materials">

          <b-col :class="rightTable ? 'col-md-4' : 'col-md-2'">
            <AppSearchInput
              :label="$t('search')+':'"
              :placeholder="$t('search')"
              @callback="search"
            />
          </b-col>

          <b-col class="col-md-6 text-right ml-auto">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-works
              style="margin-top: 18px"
              variant="primary"
              @click="editWorks = null"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
              />
              {{$t('general.add')}}
            </b-button>
          </b-col>
          <b-col class="col-md-12">
            <b-table
              class="border"
              :fields="fields"
              :items="GET_ALL_BRIGADE_WORK_CATEGORIES.results"
              show-empty
              responsive
              selectable
              select-mode="single"
              :empty-text="$t('empty_text')"
              @row-clicked="onRowSelected"
            >
              <template #head()="props">
                <span>{{ $t(props.label) }}</span>
              </template>

              <template #cell(title)="props">
                <span>{{ props.item.title[$i18n.locale] }}</span>
              </template>

              <template #cell(actions)="props">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.modal-works
                  size="sm"
                  class="ml-2 mt-50 mb-50"
                  variant="warning"
                  @click="editWorks = props.item"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="15"
                  />
                </b-button>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  size="sm"
                  variant="danger"
                  class="ml-50 mt-50 mb-50"
                  @click="deleteWorkCategory(props)"
                >
                  <feather-icon icon="TrashIcon" size="15" />
                </b-button>

              </template>

            </b-table>
            
            <Pagination
              class="mt-2"
              :nobody="true"
              :rows="GET_ALL_BRIGADE_WORK_CATEGORIES.count"
              :params="params"
              @refresh="refresh()"
            />
          </b-col>

        </b-row>
      </b-col>

      <b-col v-show="rightTable">
        <childWorks
          :item="item"
        />
      </b-col>
    </b-row>

    <addWorks
      :edit-data="editWorks"
      @save="refresh"
    />
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BRow,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import childWorks from '@/views/modules/Reference/works/childWorks.vue'
import Pagination from '@/components/Pagination.vue'
import addWorks from './modals/addWorks.vue'

export default {
  components: {
    BButton,
    BCol,
    BRow,
    BTable,
    childWorks,
    AppSearchInput,
    Pagination,
    addWorks,
  },
  directives: {
    Ripple,
  },
  data() {
    return {





      // ===============  PRIMARY_DATA_SECTION START ===============
      rightTable: false,
      item: null,
      editWorks: null,
      params: {
        search: null,
        page_size: 10,
        page: 1,
      },
      card_fullscreen: false,
      // ===============  PRIMARY_DATA_SECTION END ===============










      // ===============  SECONDARY_DATA_SECTION START ===============
      fields: [
        {
          label: 'id',
          key: 'id',
        },
        {
          label: 'namee',
          key: 'title',
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: 'actions',
          key: 'actions',
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      // ===============  SECONDARY_DATA_SECTION END ===============





    }
  },
  computed: {
    ...mapGetters('brigadeWorks', ['GET_BRIGADE_WORK_CATEGORIES', 'GET_ALL_BRIGADE_WORK_CATEGORIES']),
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh()
    // ===============  PRIMARY_REQUESTS_SECTION END ===============


  },
  methods: {
    ...mapActions('brigadeWorks', ['FETCH_ALL_BRIGADE_WORKS', 'FETCH_ALL_BRIGADE_WORK_CATEGORIES', 'DELETE_BRIGADE_WORK_CATEGORIES']),





    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      await this.FETCH_ALL_BRIGADE_WORK_CATEGORIES({ ...this.params })
    },
    // ===============  REFRESH_SECTION END ===============






    // ===============  FILTER_SECTION START ===============
    async onRowSelected(item) {
      this.$router.replace({ path: "/reference", query: { category: item.id } });

      try {
        await this.FETCH_ALL_BRIGADE_WORKS({
          category: item.id,
        }).then(() => {

        })
        .catch((error) => {
          console.log(error)
        })
        this.rightTable = true
      } catch (error) {
          console.log(error)
      }

    },




    async search(text) {
      this.params.search = text
      await this.refresh()
    },
    // ===============  FILTER_SECTION END ===============









    // ===============  DELETE_SECTION START ===============
    async deleteWorkCategory(props) {
      this.$_showAreYouSureModal().then( async (val) => {
        if (val) {
          this.DELETE_BRIGADE_WORK_CATEGORIES(props.item.id)
            .then( async () => {
              await this.refresh()
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============







  },
}
</script>

<style>
.card-fullscreen {
  display: block;
  z-index: 1032;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 40px;
  background-color: #F8F8F8;
}

.full-screen {
  padding: 27px 7px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
}

.table-materials .table.b-table > tbody > .table-active, [dir] .table.b-table > tbody > .table-active > th, [dir] .table.b-table > tbody > .table-active > td {
  color: #fff;
  background-color: #5a9cd9 !important;
}
</style>
